import { IEsfDailyStatus } from "shared/api/api";
import { Syncable } from "shared/state/models/syncable";
export const GET_EsfDailyStatusData = 'GET_EsfDailyStatusData';
export const SAVE_EsfDailyStatusData = 'SAVE_EsfDailyStatusData';

export const REMOVE_DAILY_STATUS = 'REMOVE_DAILY_STATUS';

export interface EsfDailyStatusDataState extends Syncable<IEsfDailyStatus> {}